import React from 'react';
import { Section } from './Section';
import { CheckCircle2Icon } from 'lucide-react';
export const Expert = () => {
  return <Section className="bg-stone-50" data-id="element-68">
      <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-stone-100 max-w-4xl mx-auto" data-id="element-69">
        <div className="grid md:grid-cols-5 items-center" data-id="element-70">
          <div className="md:col-span-2 h-full" data-id="element-71">
            <img src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=format&fit=crop&q=80&w=800" alt="Dr. Martín Aguirre" className="w-full h-full object-cover min-h-[300px] md:min-h-[400px]" data-id="element-72" />
          </div>
          <div className="md:col-span-3 p-8 md:p-10" data-id="element-73">
            <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-2" data-id="element-74">
              Conoce al creador
            </h2>
            <p className="text-brand-700 font-medium mb-6 text-lg" data-id="element-75">
              Dr. Martín Aguirre Pitoia
            </p>

            <p className="text-stone-600 mb-6 leading-relaxed" data-id="element-76">
              "Durante mis más de 8 años como Especialista en Nutrición Clínica,
              he visto a cientos de pacientes frustrados porque sus dietas los
              hacían sentir peor. La salud tiroidea no se trata de comer menos,
              sino de comer <em data-id="element-77">mejor</em>. Creé{' '}
              <strong data-id="element-78">Plan Tiroides 360</strong> para demostrar que nutrir tu
              cuerpo puede ser un proceso delicioso, simple y profundamente
              sanador."
            </p>

            <ul className="space-y-3" data-id="element-79">
              {['Especialista en Nutrición Clínica y Metabolismo', 'Más de 8 años de experiencia con pacientes tiroideos', 'Enfoque en alimentación antiinflamatoria real'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-80">
                  <CheckCircle2Icon className="w-5 h-5 text-brand-600 shrink-0 mt-0.5" data-id="element-81" />
                  <span className="text-stone-700 font-medium" data-id="element-82">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
};